module.exports = __webpack_public_path__ + "static/media/arrow.0a4b9513.svg";